import API from '../utils/request'

// 获取车辆基本信息
export function getCarInfo(carNumber) {
    return API({
        url: `/system/registration/getInfoByCarNumber/${carNumber}`,
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}

// 获取车辆租还记录
export function getHire({ pageNum, pageSize, carNumber }) {
    return API({
        url: `/system/hire/getInfoByCarNumber/${carNumber}?pageNum=${pageNum}&pageSize=${pageSize}`,
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}


// 获取维保记录
export function getMaintenance({ pageNum, pageSize, carNumber }) {
    return API({
        url: `/system/maintenance/getInfoByCarNumber/${carNumber}?pageNum=${pageNum}&pageSize=${pageSize}`,
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}


// 获取车辆事故处理记录
export function getProtection({ pageNum, pageSize, carNumber }) {
    return API({
        url: `/system/protection/getInfoByCarNumber/${carNumber}?pageNum=${pageNum}&pageSize=${pageSize}`,
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}

// 获取车辆维保记录
export function getInsurance({ pageNum, pageSize, carNumber }) {
    return API({
        url: `/system/insurance/getInfoByCarNumber/${carNumber}?pageNum=${pageNum}&pageSize=${pageSize}`,
        headers: {
            'Content-Type': "application/json;charset=utf-8"
        }
    })
}